import React, { Component } from 'react'
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { browserHistory } from 'react-router'

class UNIceff extends Component {

    componentDidMount() {
        document.title = this.props.t('homeContent.employment', { param: 'react' })
    }

    render() {
        return (
            <div className="tab-content" style={{ "border": "none" }}>
                <div id="home" className=" tab-pane active">
                    <section className="login-form mt-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow mb-3 mt-3  ">
                                    <div className="panel-body p-policy mt-4 p-4">
                                        <h1>Employement related AI Tools - UNICEFF</h1>
                                        <h2>Report on AI Tools</h2>

                                        <h3>Warm (Interview Warm-up by Google)</h3>
                                        <p><strong>Purpose:</strong> AI-powered tool that helps users prepare for job interviews by simulating common interview questions.</p>
                                        <p><strong>Details:</strong> Provides real-time feedback on user responses, analyzing answers to offer improvement insights.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aeia-label="Interview Warm-up by Google"
                                        href="https://grow.google/certificates/interview-warmup/" target="_blank">Interview Warm-up</a></p>
                                        <p><strong>Paid or Not:</strong> Free</p>

                                        <h3>Yoodli</h3>
                                        <p><strong>Purpose:</strong> AI-based tool for public speaking and communication improvement.</p>
                                        <p><strong>Details:</strong> Analyzes speech patterns, offering feedback on pacing, filler words, and tone.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aria-label='Yoodli'
                                        href="https://www.yoodli.ai/" target="_blank">Yoodli</a></p>
                                        <p><strong>Paid or Not:</strong> Free basic plan, with paid premium features.</p>

                                        <h3>Interviewsby.ai</h3>
                                        <p><strong>Purpose:</strong> AI-based platform for realistic interview practice.</p>
                                        <p><strong>Details:</strong> Simulates real interview environments with AI-generated questions and feedback.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aria-label='Interviewsby.ai'
                                        href="https://interviewsby.ai/" target="_blank">Interviewsby.ai</a></p>
                                        <p><strong>Paid or Not:</strong> Free plan available; paid plans for additional features.</p>

                                        <h3>Zety</h3>
                                        <p><strong>Purpose:</strong> AI-based resume builder and career development tool.</p>
                                        <p><strong>Details:</strong> Provides templates and AI-powered suggestions for resume improvement.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aria-label='Zety'
                                        href="https://zety.com/" target="_blank">Zety</a></p>
                                        <p><strong>Paid or Not:</strong> Paid tool (with limited free access).</p>

                                        <h3>Resume.io</h3>
                                        <p><strong>Purpose:</strong> Online AI-driven resume builder and cover letter generator.</p>
                                        <p><strong>Details:</strong> Provides professional templates with AI-powered content suggestions.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aria-label='Resume.io'
                                        href="https://resume.io/" target="_blank">Resume.io</a></p>
                                        <p><strong>Paid or Not:</strong> Paid tool (with free trial options).</p>

                                        <h3>Kickresume</h3>
                                        <p><strong>Purpose:</strong> AI-powered resume, cover letter, and website builder.</p>
                                        <p><strong>Details:</strong> Offers resume creation, career advice, and personal website building.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aria-label='Kickresume'
                                        href="https://www.kickresume.com/" target="_blank">Kickresume</a></p>
                                        <p><strong>Paid or Not:</strong> Free plan available, with premium paid options.</p>

                                        <h3>Jobscan</h3>
                                        <p><strong>Purpose:</strong> AI tool for optimizing resumes for Applicant Tracking Systems (ATS).</p>
                                        <p><strong>Details:</strong> Compares resumes against job descriptions and offers keyword optimization insights.</p>
                                        <p><strong>Visiting URL:</strong> <a 
                                        aria-label='Jobscan'
                                        href="https://www.jobscan.co/" target="_blank">Jobscan</a></p>
                                        <p><strong>Paid or Not:</strong> Free for limited scans, paid plans available for full access.</p>

                                        <h3>Summary Table</h3>
                                        <table>
                                            <tr>
                                                <th>Tool</th>
                                                <th>Purpose</th>
                                                <th>URL</th>
                                                <th>Free/Paid</th>
                                            </tr>
                                            <tr>
                                                <td>Interview Warm-up</td>
                                                <td>AI-powered interview preparation</td>
                                                <td><a 
                                                aria-label='Visit Interview Warm-up by Google'
                                                href="https://grow.google/certificates/interview-warmup/" target="_blank">Visit</a></td>
                                                <td>Free</td>
                                            </tr>
                                            <tr>
                                                <td>Yoodli</td>
                                                <td>Public speaking and communication improvement</td>
                                                <td><a 
                                                aria-label='Visit Yoodli'
                                                href="https://www.yoodli.ai/" target="_blank">Visit</a></td>
                                                <td>Free (with premium features)</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(UNIceff));
